import { Layout } from "antd";
import Sidebar from "@/components/Sidebar/Sidebar";
import Navbars from "@/components/Navbars/Navbars";
import { Outlet } from "react-router-dom";
import { useDashboardDataContext } from "@/context/dashboardDataContext";

const { Content } = Layout;

const Layouts = () => {
  const { navbarFixed, sidebarMini } = useDashboardDataContext();

  const isMobile = window.innerWidth < 992;
  const sidebarWidth = sidebarMini ? 80 : 280;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />

      <Layout
        className="site-layout"
        style={{
          marginLeft: isMobile ? 0 : sidebarWidth,
          transition: "margin-left 0.2s ease",
        }}
      >
        <Navbars />
        <Content
          style={{
            marginTop: navbarFixed ? 64 : 64,
            padding: "16px 24px",
            minHeight: "calc(100vh - 64px)",
            background: "#f5f6fa",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default Layouts;
